import { ContentBox } from "@msuite/ui/content-box";
import { ArticlesTable } from "@/components/stock/articles-table";
import { ArticlesMenu } from "./articles-menu";

export function Articles() {
	/** Render */
	return (
		<ContentBox>
			<ArticlesTable
				menu={<ArticlesMenu />}
				variant="table"
			/>
		</ContentBox>
	);
}
